<div>
    <div *ngIf="!loaded">
        <app-spinner></app-spinner>
    </div>
    <div *ngIf="loaded">

        <div us-spinner="{ position: 'relative'}" spinner-key="buildingInformationHistorySpinner"
            spinner-start-active="true">

            <h2 *ngIf="showNoRequestsFound">No Building Information requests found</h2>

            <div class="table-responsive">
                <table class="table table-striped" *ngIf="!showNoRequestsFound && buildingInformationHistory">
                    <thead>
                        <tr>
                            <th class="col-xs-1">Request ID</th>
                            <th class="col-xs-1">Date of Request</th>
                            <th class="col-xs-1">Categories</th>
                            <th class="col-xs-3">Date Completed/Declined</th>
                            <th class="col-xs-6">Status Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr></tr>
                        <tr *ngFor="let informationRequest of buildingInformationHistory">

                            <td>{{informationRequest.uniqueReference}}</td>
                            <td>{{informationRequest.dateReported}}</td>
                            <td>{{informationRequest.primaryCategoriesString}}</td>
                            <td>{{informationRequest.dateCompleted}}</td>
                            <td>{{informationRequest.statusReason}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div>